import { LinearProgress } from '@mui/material';
import styles from './mainPreloader.module.css';

export const MainPreloader = () => {
  return (
    <div className={styles.mainPreloader}>
      <div className={styles.container}>
        <LinearProgress />
      </div>
    </div>
  );
};
